import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Eye, ArrowRight, Sparkles } from 'lucide-react';

interface DemoBannerProps {
  position?: 'top' | 'bottom';
}

const DemoBanner: React.FC<DemoBannerProps> = ({ position = 'top' }) => {
  const navigate = useNavigate();

  const handleSignUp = () => {
    navigate('/login');
  };

  return (
    <div 
      className={`
        fixed ${position === 'top' ? 'top-0' : 'bottom-0'} left-0 right-0 z-[100] 
        bg-gradient-to-r from-purple-600 via-blue-600 to-indigo-600 
        border-b-2 border-purple-400/30 shadow-lg
        ${position === 'top' ? 'border-b-2' : 'border-t-2'}
      `}
    >
      <div className="px-4 py-3 flex items-center justify-between max-w-screen-2xl mx-auto">
        {/* Left side - Demo indicator */}
        <div className="flex items-center gap-3">
          <div className="flex items-center gap-2 bg-white/20 backdrop-blur-sm px-3 py-1.5 rounded-full">
            <Eye size={16} className="text-white" />
            <span className="text-white font-bold text-sm">Demo Mode</span>
          </div>
          <span className="text-white/90 text-sm hidden md:block">
            You're exploring with sample data • All features visible, actions disabled
          </span>
        </div>

        {/* Right side - CTA buttons */}
        <div className="flex items-center gap-3">
          <button
            onClick={handleSignUp}
            className="
              flex items-center gap-2 
              bg-white text-purple-600 
              px-4 py-2 rounded-lg 
              font-bold text-sm
              hover:bg-purple-50 
              transition-all duration-200
              shadow-lg hover:shadow-xl
              hover:scale-105
              group
            "
          >
            <Sparkles size={16} className="group-hover:rotate-12 transition-transform" />
            <span>Sign Up to Trade</span>
            <ArrowRight size={16} className="group-hover:translate-x-1 transition-transform" />
          </button>
          
          <button
            onClick={() => navigate('/login')}
            className="
              text-white font-semibold text-sm
              px-4 py-2
              border-2 border-white/30 rounded-lg
              hover:bg-white/10 hover:border-white/50
              transition-all duration-200
            "
          >
            Log In
          </button>
        </div>
      </div>

      {/* Animated gradient line */}
      <div className="h-1 bg-gradient-to-r from-transparent via-white/40 to-transparent animate-shimmer"></div>
      
      <style>{`
        @keyframes shimmer {
          0% { transform: translateX(-100%); }
          100% { transform: translateX(100%); }
        }
        .animate-shimmer {
          animation: shimmer 3s infinite;
          background: linear-gradient(90deg, transparent, rgba(255,255,255,0.4), transparent);
          background-size: 200% 100%;
        }
      `}</style>
    </div>
  );
};

export default DemoBanner;

